import { useContent } from "@/context/ContentContext";
import useMeta from "@/hooks/useMeta";
import { paragraphs } from "@/lib/api";
import { PageHero } from "@/components/site/PageHero";

const WithEmail = ({ text, email }) => {
  const parts = text.split("{email}");
  return parts.map((p, i) => (
    <span key={i}>
      {p}
      {i < parts.length - 1 && <a href={`mailto:${email}`} className="text-link">{email}</a>}
    </span>
  ));
};

export default function Privacy() {
  const { content } = useContent();
  const p = content.privacy;
  useMeta("Privacy Policy", "How Violet Psychotherapy handles the information you share through this website.");
  return (
    <>
      <PageHero title={p.headline} testId="privacy-headline" />
      <section className="wrap pb-24">
        <div className="max-w-2xl space-y-5 text-base leading-[1.85] text-[#22304A]/85" data-testid="privacy-body">
          {paragraphs(p.body).map((para, i) => (
            <p key={i}><WithEmail text={para} email={content.settings.contact_email} /></p>
          ))}
        </div>
      </section>
    </>
  );
}
